module.exports = __webpack_public_path__ + "img/A_TalkBeforeAction.f5ad9eac.gif";